/**
 * @generated SignedSource<<ba3edf7fa56327c64dd89f97fd193571>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MarkupType = "FIXED" | "STANDARD";
export type PackageWarningFilter = "ANY" | "FLIGHT_UPDATE_PAST_DUE" | "HOTEL_CLOSED" | "HOTEL_DELETED" | "HOTEL_MISSING_DESCRIPTION" | "NONE" | "ROOM_DELETED" | "ROOM_MISSING_NAME" | "ROOM_NO_CAPACITY" | "ROOM_PRICE_UPDATE_FAILED";
export type SortDirection = "ASC" | "DESC";
export type PackagesFilterInput = {
  category?: ReadonlyArray<string> | null;
  catering?: ReadonlyArray<string> | null;
  country?: ReadonlyArray<string> | null;
  departure?: ReadonlyArray<string> | null;
  destination?: ReadonlyArray<string> | null;
  duration?: ReadonlyArray<number> | null;
  hasWarning?: PackageWarningFilter | null;
  markupType?: MarkupType | null;
  price?: ReadonlyArray<number> | null;
  rating?: ReadonlyArray<number> | null;
  region?: ReadonlyArray<string> | null;
  slug?: string | null;
  startDate?: string | null;
  startDates?: ReadonlyArray<string> | null;
};
export type PackageSorting = {
  createdAt?: SortDirection | null;
  markupAmount?: SortDirection | null;
  name?: SortDirection | null;
  price?: SortDirection | null;
  priceChange?: SortDirection | null;
  updatedAt?: SortDirection | null;
};
export type PackageListRefetchQuery$variables = {
  after?: string | null;
  filters?: PackagesFilterInput | null;
  first: number;
  search?: string | null;
  sort?: PackageSorting | null;
};
export type PackageListRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageList_data">;
};
export type PackageListRefetchQuery = {
  response: PackageListRefetchQuery$data;
  variables: PackageListRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sort"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PackageListRefetchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PackageList_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PackageListRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          },
          {
            "kind": "Variable",
            "name": "search",
            "variableName": "search"
          },
          {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
          }
        ],
        "concreteType": "PackageConnection",
        "kind": "LinkedField",
        "name": "packages",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PackageEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Package",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "price",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "updatedBy",
                    "plural": false,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deletable",
                        "storageKey": null
                      }
                    ],
                    "type": "Entity",
                    "abstractKey": "__isEntity"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "99722869e8d99be23589968bd6b872f2",
    "id": null,
    "metadata": {},
    "name": "PackageListRefetchQuery",
    "operationKind": "query",
    "text": "query PackageListRefetchQuery(\n  $after: String\n  $filters: PackagesFilterInput\n  $first: Int!\n  $search: String\n  $sort: PackageSorting\n) {\n  ...PackageList_data\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment PackageListRow_package on Package {\n  id\n  name\n  price\n  createdAt\n  updatedAt\n  status\n  createdBy {\n    name\n    id\n  }\n  updatedBy {\n    name\n    id\n  }\n  ...EntityTableRow_entity\n  ...PackageStatus_package\n}\n\nfragment PackageList_data on Query {\n  packages(first: $first, after: $after, search: $search, sort: $sort, filters: $filters) {\n    edges {\n      node {\n        id\n        ...PackageListRow_package\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n}\n\nfragment PackageStatus_package on Package {\n  status\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n"
  }
};
})();

(node as any).hash = "69ba01d10bb40552ecdbd8dfc8229dff";

export default node;
